import React from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "../../../shared/hooks/useHistory";
import Typography from "@material-ui/core/Typography";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles, Grid, Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  formWrapper: {
    width: "100%",
    maxWidth: 400,
    padding: "0 40px",
  },
  loginContent: {
    width: "100%",
    backgroundColor: "#4187B6",
    minHeight: "100VH",
  },
  wrapperLogin: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  logo: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 40,
    width: "100%",
    maxWidth: 200,
  },
  loginLeftContent: {
    backgroundColor: "#FFFFFF",
    minHeight: "100VH",
    height: "100%",
    width: "50%",
    marginTop: 0,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 0",
      width: "100%",
    },
  },
  errorMessage: {
    fontSize: "12px",
    color: "#f59394",
  },
  upperMargin: {
    marginTop: 20,
  },
  mainError: {
    fontSize: "15px",
    color: "#f59394",
    fontWeight: "bold",
  },
}));

export const DeclinedPage = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { search } = location;
  const errorMessage = search.slice(7);

  const setPreviousLocation = () => {
    history.goBack();
  };

  return (
    <div className={classes.loginContent}>
      <CssBaseline />
      <div className={classes.wrapperLogin}>
        <div className={[classes.paper, classes.loginLeftContent].join(" ")}>
          <div className={classes.formWrapper}>
            <img
              className={classes.logo}
              src="/logo-fruition.webp"
              alt="Logo Fruition"
            />
            <img className={classes.logo} src="/declined.svg" alt="Declined" />
            <Typography className={classes.mainError} component="p" variant="p">
              {errorMessage}
            </Typography>
            <Typography className={classes.errorMessage}>
              {` We are having trouble authorizing your payment for the
              subscription. Please verify or update your payment method. If your
              payment information is correct, please contact your bank for more
              details.`}
            </Typography>
            <Grid lg={12} sm={12}>
              <Button
                fullWidth
                className={classes.upperMargin}
                variant="contained"
                color="primary"
                onClick={setPreviousLocation}
              >
                Try again
              </Button>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};
